import fox from "../../assets/reading-fox.png";
export default function LoginForm() {
  return (
    <main
      id="main-content"
      dir="rtl"
      style={{
        display: "flex", justifyContent: "center", alignItems: "center",
        minHeight: "100dvh", padding: "1.5rem", fontFamily: "var(--font-family)",
        background: "var(--bg)", boxSizing: "border-box",
      }}
    >
      <div style={{
        display: "flex", flexDirection: "column", gap: "1.25rem",
        padding: "2.5rem 2rem", background: "var(--card)",
        borderRadius: "var(--radius)",
        boxShadow: "var(--card-shadow)",
    border: "1px solid var(--surface-border)",
        width: "min(320px, 100%)",
        alignItems: "center",
      }}>
        <img className="brand-fox" src={fox} alt="" />
        <h1 style={{ margin: 0, color: "var(--text)", fontSize: "1.5rem" }}>התחברות להורים</h1>
        <a
          href="/api/auth/google"
          role="button"
          style={{
            display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem",
            padding: "0.75rem 1.25rem", borderRadius: "var(--radius-sm)",
            border: "1px solid var(--border)",
            background: "white", color: "#333",
            textDecoration: "none", fontSize: "0.95rem", fontFamily: "inherit",
            fontWeight: 500, cursor: "pointer", width: "100%", boxSizing: "border-box",
          }}
        >
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
            <path fill="#34A853" d="M10.53 28.59a14.5 14.5 0 010-9.18l-7.98-6.19a24.09 24.09 0 000 21.56l7.98-6.19z"/>
            <path fill="#FBBC05" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
          </svg>
          כניסה עם Google
        </a>
      </div>
    </main>
  );
}
